export const ATTRIBUTE_SOURCE_OPTIONS = [
  { value: 'brand', label: 'Marca' },
  { value: 'atributo1', label: 'Atributo 1' },
  { value: 'atributo2', label: 'Atributo 2' },
  { value: 'atributo3', label: 'Atributo 3' },
  { value: 'ramo', label: 'Ramo' },
  { value: 'linea', label: 'Línea' },
  { value: 'clase', label: 'Clase' },
  { value: 'sku', label: 'Código (SKU)' },
  { value: 'barcode', label: 'Código de barras' },
  { value: 'taxRate', label: 'Tasa IVA' },
  { value: 'unit', label: 'Unidad / empaque' },
  { value: 'inStock', label: 'Disponibilidad' },
] as const;

export type AttributeSourceValue = (typeof ATTRIBUTE_SOURCE_OPTIONS)[number]['value'];

export type CardFieldGroup = {
  id: string;
  label: string;
  options: ReadonlyArray<{ value: string; label: string }>;
};

export const CARD_FIELD_GROUPS: readonly CardFieldGroup[] = [
  {
    id: 'producto',
    label: 'Producto',
    options: [
      { value: 'none', label: '(ninguno)' },
      { value: 'name', label: 'Nombre' },
      { value: 'brand', label: 'Marca' },
      { value: 'price', label: 'Precio' },
      { value: 'sku', label: 'SKU / Código' },
      { value: 'barcode', label: 'Código de barras' },
    ],
  },
  {
    id: 'clasificacion',
    label: 'Clasificación ERP',
    options: [
      { value: 'ramo', label: 'Ramo' },
      { value: 'linea', label: 'Línea' },
      { value: 'clase', label: 'Clase' },
    ],
  },
  {
    id: 'erp',
    label: 'Datos ERP',
    options: [
      { value: 'atributo1', label: 'Atributo 1' },
      { value: 'atributo2', label: 'Atributo 2' },
      { value: 'atributo3', label: 'Atributo 3' },
      { value: 'taxRate', label: 'Tasa IVA' },
      { value: 'unit', label: 'Unidad / empaque' },
      { value: 'inStock', label: 'Disponibilidad' },
    ],
  },
];
